import {integrityProfSpac} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useLoadIntegrityProfSpac(selection: any) {
  return useLoad(integrityProfSpac, 'revision', {values: selection});
}

export default useLoadIntegrityProfSpac;
